import { PaymentError } from '../types/PaymentError'

/** Check if a PaymentError was classified as a network error */
export const isPaymentNetworkError = (error: PaymentError) => {
  return error.type.startsWith('/errors/payment/network-error')
}
